import { useSelector } from 'react-redux'

import {
  DbtTeenCareStatusResult,
  getDbtTeenCareStatus,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/userUtils'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { getCustomerName } from '../data/customer/customerSelectors'
import { getInProgressEpisodes, getProviders } from '../data/lyraTherapy/lyraTherapySelectors'
import { getIsUserTeen } from '../data/user/userSelectors'
import { getNonCanceledAppointments } from '../features/appointmentDashboard/data/appointmentDashboardSelectors'

/** Returns the shared DBT teen identity and active-care decisions for the current LyraWeb user. */
export const useDbtTeenCareStatus = (): DbtTeenCareStatusResult => {
  const customerName = useSelector(getCustomerName)
  const isUserTeen = useSelector(getIsUserTeen)
  const episodes = useSelector(getInProgressEpisodes)
  const appointments = useSelector(getNonCanceledAppointments)
  const careProviders = useSelector(getProviders)
  const { isDBTTeensEnabled } = useFlags()

  return getDbtTeenCareStatus({
    customerName,
    isDbtTeensEnabled: isDBTTeensEnabled,
    isUserTeen,
    episodeCount: episodes?.size,
    appointmentCount: appointments?.size,
    careProviderCount: careProviders?.size,
  })
}
